import axios from 'axios';
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { onAxiosResponse } from 'data_system/token_auth/utils';

import { rootReducer } from '../reducers/rootReducer';
import { rootSaga } from '../sagas/rootSaga';

const { pathname } = window.location;
const slug = pathname.split('/')[2];

export const history = createBrowserHistory({ basename: `/a/${slug}/` });

const sagaMiddleware = createSagaMiddleware();

const middlewares = [routerMiddleware(history), sagaMiddleware];

// create a redux store with our reducer above and middleware
// (Redux devtools version)
const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composeEnhancers = devTools
  ? devTools({ name: 'Affiliate Portal' })
  : compose;
export const store = createStore(
  rootReducer(history),
  composeEnhancers(applyMiddleware(...middlewares))
);

const responseInterceptor = [
  (response) => {
    onAxiosResponse(response, store);
    return Promise.resolve(response);
  },
  (error) => {
    onAxiosResponse(error.response, store);
    return Promise.reject(error);
  },
];

axios.interceptors.response.use(...responseInterceptor);

// run the saga
sagaMiddleware.run(rootSaga);
